import { type RefObject, useEffect } from 'react'

/**
 * 任意の要素の外側クリックを検知するフック。Popover / Drop-down 系で使う。
 *
 * - `enabled=false` の間は listener を登録しない (常時購読を避ける)
 * - mousedown を採用 (click より早く発火し、focus 遷移より前に閉じられる)
 * - 同じ要素ツリー内のクリックは無視する (`ref.current.contains(e.target)`)
 */
export const useOutsideClick = (
  ref: RefObject<HTMLElement | null>,
  enabled: boolean,
  onOutside: () => void,
): void => {
  useEffect(() => {
    if (!enabled) return

    const handler = (e: MouseEvent): void => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onOutside()
      }
    }

    document.addEventListener('mousedown', handler)

    return (): void => document.removeEventListener('mousedown', handler)
  }, [enabled, ref, onOutside])
}
